<template>
    <b-modal ref="mdlPazientiMenuEdit" size="xl" :title="titoloModale" no-close-on-backdrop no-close-on-esc centered scrollable>
        <div class="sa-tab-scroll">
            <b-card class="sa-card sa-card-border" header=" " header-tag="header" footer-tag="footer" title="">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <span class="sa-label-data">Text</span>
                        <b-form-input v-model="jsonDataPazientiMenu.text"> </b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <span class="sa-label-data">View Id</span>
                        <b-form-input v-model="jsonDataPazientiMenu.viewId" disabled></b-form-input>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <span class="sa-label-data">Leaf</span>
                        <b-form-checkbox v-model="jsonDataPazientiMenu.leaf" :options="options" disabled></b-form-checkbox>
                    </b-col>

                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <span class="sa-label-data">Icon-cls</span>
                        <b-form-input v-model="jsonDataPazientiMenu.iconCls" disabled></b-form-input>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <span class="sa-label-data">Route Id</span>
                        <b-form-input v-model="jsonDataPazientiMenu.routeId" disabled></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <span class="sa-label-data">Ordering</span>
                        <b-form-input v-model="jsonDataPazientiMenu.ordering"></b-form-input>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <span class="sa-label-data">Expanded</span>
                        <b-form-checkbox v-model="jsonDataPazientiMenu.expanded" :options="options" disabled></b-form-checkbox>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <span class="sa-label-data">Selectable</span>
                        <b-form-checkbox v-model="jsonDataPazientiMenu.selectable" :options="options" disabled></b-form-checkbox>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <span class="sa-label-data">Tipo</span>
                        <b-form-input v-model="jsonDataPazientiMenu.tipo" disabled></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <span class="sa-label-data">Id padre</span>
                        <b-form-input v-model="jsonDataPazientiMenu.idPadre" disabled></b-form-input>
                    </b-col>
                </b-row><b-row>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <span class="sa-label-data">Application Reference</span>
                        <b-form-select v-model="jsonDataPazientiMenu.applicationReference" :options="optionsApplicationReference" ></b-form-select>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <span class="sa-label-data">Regime Reference</span>
                        <b-form-input v-model="jsonDataPazientiMenu.regimeReference" ></b-form-input>
                    </b-col>
                </b-row>
            </b-card>
        </div>
        <template #modal-footer>
            <b-button size="md" variant="outline-secondary" @click="onClickIndietro"> Annulla </b-button>

            <!--<b-button size="md" variant="outline-danger" @click="onClickAnnulla"> Annulla </b-button>-->

            <b-button variant="outline-success" @click="onSalvaVoceMenu"> Salva Riga </b-button>
        </template>
    </b-modal>
</template>
<script>
import UtilityMixin from "../../utility/UtilityMixin";
export default {
    mixins: [UtilityMixin],
    name: "ConfigurazioneGeneralePazientiMenuModalEditComponent",

    data() {
        return {
            titoloModale: "Modifica Voce Menu",
            jsonDataPazientiMenu: {
                text: "",
                viewId: "",
                leaf: false,
                iconCls: "",
                routeId: "",
                ordering: "",
                expanded: false,
                selectable: false,
                idPadre: "",
                tipo: "",
                applicationReference: "",
                regimeReference: "",
            },
            pathResource: "/rsapazientimenu",
            options: [
                { text: "SI", value: true },
                { text: "NO", value: false },
            ],
            optionsApplicationReference: [
                { text: "-Seleziona valore-", value: null },
                { text: "APP", value: "APP" },
            ],
        };
    },

    methods: {
        show(item) {
            this.jsonDataPazientiMenu = Object.assign({}, item);
            this.$refs.mdlPazientiMenuEdit.show(item);
        },
        onClickIndietro() {
            this.$refs.mdlPazientiMenuEdit.hide();
        },
        onSalvaVoceMenu() {
            let me = this;
            me.saveResource(me.pathResource, me.jsonDataPazientiMenu, me.loadDataPazientiMenuSuccess, me.loadDataPazientiMenuError);
        },
        saveResource(pathResource, body, resultResponse, resultError) {
            let link = process.env.VUE_APP_PATH_API + pathResource;
            link = link + "/" + body.routeId;
            UtilityMixin.methods.restCallPut(link, body, resultResponse, resultError);
        },
        loadDataPazientiMenuSuccess() {
            this.$bvModal.msgBoxOk("Voce menu salvata con successo.", {
                title: "Salvataggio completato",
                size: "sm",
                okVariant: "success",
                centered: true,
            });
            this.$refs.mdlPazientiMenuEdit.hide();
            this.$emit("afterSave");
        },
        loadDataPazientiMenuError(error) {
            console.log("Errore nel salvataggio della voce menu:", error.response.data.messaggio);
        },
    },
};
</script>
